<template>
    <div class="wrapper">
        <h1>{{ $t('labels.enter_team') }}</h1>

        <div class="button-grid" v-if="showTeamsAsButtons">
            <button
                    type="button"
                    :class="getButtonClasses(team)"
                    v-for="team in visible"
                    :key="team.id"
                    :style="'background: ' + (team.color ? team.color : '#0a8bc8')"
                    @click="selectTeam(team)"
                    v-text="team.name"
            ></button>
        </div>

        <input name="team_name" id="team_name" class="form-control form-control--large" v-model="value" disabled v-else>

        <div class="row">
            <div class="col-md-4">
                <cancel-button :redirect="cancel()" clearActivity="true"></cancel-button>
            </div>
        </div>
    </div>
</template>

<script>
import {writeTrackLog} from "../utils/tracking";
import CancelButton from "../components/app/CancelButton";

export default {
  components: {CancelButton},

  data() {
    return {
      value: '',
      cancelActivity: false
    }
  },

  computed: {
    currentDevice() {
      return this.$store.state.currentDevice;
    },

    currentEmployee() {
      return this.$store.state.currentEmployee;
    },

    currentActivity() {
      return this.$store.getters.currentActivityForEmployee;
    },

    teams() {
      return this.$store.state.teams
    },

    teamsOrder() {
      return this.$store.state.teamsOrder;
    },

    visible() {
      const ordered = this.teamsOrder
          ? this.teamsOrder.split('|')
          : this.currentDevice && this.currentDevice.teams_order ? this.currentDevice.teams_order : [];

      return this.teams
          .filter(team => ordered.indexOf(team.id.toString()) > -1)
          .map(team => {
            team.order = ordered.indexOf(team.id.toString());

            return team;
          })
          .sort((a, b) => {
            if (a.order > b.order) return 1;
            if (a.order < b.order) return -1;
            return 0;
          });
    },

    showTeamsAsButtons() {
      return this.$store.state.teamsAsButtons;
    }
  },

  methods: {
    getButtonClasses(team) {
      return {
        'action-button': true,
        'button-grid-button': true,
        'active': this.currentActivity && this.currentActivity.team_name && team.name === this.currentActivity.team_name
      };
    },

    cancel() {
      return {name: 'activity'};
    },

    selectTeam(team) {
      if (this.$store.state.enableTracking) writeTrackLog('Select team: ' + team.name);
      this.value = team.name;
      window.events.$emit('submitFromNumpad');
    }
  },

  mounted() {
    if (this.currentEmployee === null || this.currentEmployee === undefined) return this.$router.push('pin');

    if (!this.showTeamsAsButtons) {
      if (this.currentActivity !== null && this.currentActivity !== undefined && this.currentActivity.team_name !== null) {
        this.value = this.currentActivity.team_name;
      }

      window.events.$emit('enableNumpad');
    }

    window.events.$on('numpadType', value => {
      if (!this.value) this.value = '';
      if (document.getElementById('team_name')) this.value = this.value + value;
    });

    window.events.$on('backspace', () => {
      if (document.getElementById('team_name')) this.value = '';
    });

    window.events.$on('submitFromNumpad', () => {
      const field = document.getElementById('team_name');

      if (!this.showTeamsAsButtons && (field === null || field === undefined || this.value === '')) return;

      const team = this.$store.getters.teamByTitle(this.value);

      if (!team) {
        this.value = '';
        return this.$store.dispatch('setError', 'errors.team_not_found');
      }

      const oldEntry = this.currentActivity;

      if (!oldEntry || !oldEntry.id) {
        this.$store.dispatch('setError', 'errors.no_activity');
        return this.$router.push({name: 'activity'});
      }

      if (this.$store.state.enableTracking) writeTrackLog('Register team name: ' + this.value);

      const timesheetEntry = {
        ...this.currentActivity,
        ...{
          team_id: team.id,
          team_name: this.value,
        }
      };

      oldEntry.team_name = timesheetEntry.team_name;

      this.$store.commit('syncOnline', true);
      this.$store.dispatch('updateActivity', timesheetEntry);

      if (this.$parent.preRegistering) {
        return this.$store.commit('setChecked');
      }

      const route = this.$parent.determineRoute(oldEntry);

      if (route !== null && route !== undefined) return this.$router.push(route);

      return this.$router.push('activity');
    })
  },

  beforeDestroy() {
    window.events.$off('submitFromNumpad');
    window.events.$off('backspace');
    window.events.$off('numpadType');
  }
}
</script>


